import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "@studio-freight/lenis";
import { Toaster } from "sonner";
import { fetchSettings } from "./lib/api";
import { LangProvider } from "./lib/i18n";
import { Nav } from "./components/site/Nav";
import { Footer } from "./components/site/Footer";
import Home from "./pages/Home";
import EventPage from "./pages/EventPage";
import AdminPage from "./pages/AdminPage";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return null;
};

const Shell = ({ settings }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Nav ticketUrl={settings?.ticket_url} />}
      <Routes>
        <Route path="/" element={<Home settings={settings} />} />
        <Route path="/events/:slug" element={<EventPage settings={settings} />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {!isAdmin && <Footer settings={settings} />}
    </>
  );
};

function App() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchSettings().then(setSettings).catch(() => {});
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[#FDFBF7] min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <LangProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Shell settings={settings} />
        </BrowserRouter>
      </LangProvider>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
